import { render } from "./Population.vue?vue&type=template&id=511c7fa3"
import script from "./Population.vue?vue&type=script&lang=js"
export * from "./Population.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/kingdoms/Population.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "511c7fa3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('511c7fa3', __exports__)) {
    api.reload('511c7fa3', __exports__)
  }
  
  module.hot.accept("./Population.vue?vue&type=template&id=511c7fa3", () => {
    api.rerender('511c7fa3', render)
  })

}


export default __exports__